'use strict';

var _tslib = require('../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
require('../../DataDisplays/Avatar/Avatar.js');
var CountBadge = require('../../DataDisplays/CountBadge/CountBadge.js');
require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('../../DataDisplays/Label/Label.js');
var SystemIcon = require('../../DataDisplays/SystemIcon/SystemIcon.js');

const ButtonContainer = (_a)=>{
    var { rounded, size, type, variant, color, children, leadingIcon, isLeadingIconSolid = false, trailingIcon, isTrailingIconSolid = false, badgeNumber = '', className, disabled, onClick } = _a, rest = _tslib.__rest(_a, [
        "rounded",
        "size",
        "type",
        "variant",
        "color",
        "children",
        "leadingIcon",
        "isLeadingIconSolid",
        "trailingIcon",
        "isTrailingIconSolid",
        "badgeNumber",
        "className",
        "disabled",
        "onClick"
    ]);
    const generateSize = ()=>{
        if (size === 'sm') return 'h-[36px] text-sm leading-6 gap-x-1';
        if (size === 'lg') return 'h-[60px] text-[20px] leading-[30px] gap-x-2';
        return 'h-[50px] text-base leading-[26px] gap-x-1.5';
    };
    const generatePadding = ()=>{
        const isSolid = variant === 'solid';
        if (size === 'sm') return isSolid ? 'px-3' : 'px-[11px]';
        if (size === 'lg') return isSolid ? 'px-6' : 'px-[23px]';
        return isSolid ? 'px-4' : 'px-[15px]';
    };
    const generateVariant = ()=>{
        if (variant === 'solid') return 'bg-primary-500 border-0 hover:bg-primary-700';
        if (variant === 'outline_filled') return 'bg-primary-10 border-primary-200 hover:border-primary-500';
        return color === 'primary' ? 'bg-w-white border-w-gray-200 hover:border-primary-500' : 'bg-w-white border-w-gray-200 hover:border-w-gray-400';
    };
    const generateTextColor = ()=>{
        if (disabled) {
            if (variant === 'solid') return 'text-w-white';
            if (variant === 'outline_filled') return 'text-primary-100';
            if (color === 'primary') return 'text-primary-100';
            if (color === 'gray') return 'text-w-gray-300';
        }
        if (variant === 'solid') return 'text-w-white';
        if (variant === 'outline_filled') return 'text-primary-500';
        return color === 'primary' ? 'text-primary-500' : 'text-w-gray-600';
    };
    const generateDisabledStyle = ()=>{
        if (variant === 'solid') return 'bg-primary-100 border-0 hover:bg-primary-100 hover:border-primary-100';
        if (variant === 'outline_filled') return 'bg-primary-10 border-primary-200 hover:border-primary-200';
        return 'bg-w-white border-w-gray-200 hover:border-w-gray-200';
    };
    return jsxRuntime.jsxs("button", Object.assign({
        className: tailwindMerge.twMerge('box-border flex w-fit cursor-pointer items-center justify-center border', variant === 'outlined' && rounded ? 'rounded-full' : 'rounded-xl', generateSize(), generatePadding(), generateTextColor(), generateVariant(), disabled && 'cursor-not-allowed', disabled && generateDisabledStyle(), className),
        onClick: onClick,
        disabled: disabled,
        type: type
    }, rest, {
        children: [
            leadingIcon && jsxRuntime.jsx(SystemIcon, {
                name: leadingIcon,
                solid: isLeadingIconSolid,
                testId: "design-system-button--leading-icon",
                className: tailwindMerge.twMerge('flex-shrink-0', size === 'sm' ? 'size-[14px]' : 'size-4', generateTextColor())
            }),
            children,
            trailingIcon && jsxRuntime.jsx(SystemIcon, {
                name: trailingIcon,
                solid: isTrailingIconSolid,
                testId: "design-system-button--trailing-icon",
                className: tailwindMerge.twMerge('flex-shrink-0', size === 'sm' ? 'size-[14px]' : 'size-4', generateTextColor())
            }),
            badgeNumber && jsxRuntime.jsx(CountBadge, {
                text: badgeNumber,
                className: "relative flex-shrink-0"
            })
        ]
    }));
};

exports.ButtonContainer = ButtonContainer;
